type Props = {
  percentage: string;
  title: string;
  description: string;
};

export const StatInsightCard = ({ percentage, title, description }: Props) => {
  return (
    <div className="h-full rounded-[28px] lg:rounded-[40px] bg-[#EBEBEB] px-7 py-8 lg:px-[50px] lg:pt-[48px] lg:pb-[70px]">
      <div className="text-[#3A3A3A] font-medium leading-none tracking-[-3px] text-[64px] lg:text-[96px]">
        {percentage}
        <span className="text-[32px] lg:text-[44px] tracking-normal">%</span>
      </div>
      <h3 className="mt-[20px] lg:mt-7 text-[#222] text-[19px] lg:text-[26px] font-medium">{title}</h3>
      <p className="mt-[12px] lg:mt-5 text-[#333] text-[15px] lg:text-[20px] leading-[1.4]">{description}</p>
    </div>
  );
};
